import { Link } from "react-router-dom";
import { Reveal, LineReveal, ImageReveal } from "@/components/Reveal";

export default function PageHeader({ index, title, lines, subtitle, image, logo }) {
  return (
    <section className="relative pt-40 pb-20 md:pt-48 md:pb-28 overflow-hidden bg-background">
      <div className="absolute inset-0 grid-lines opacity-40" />
      <div className="relative max-w-[1500px] mx-auto px-5 md:px-10">
        <Reveal>
          <div className="font-mono text-xs uppercase tracking-widest text-primary mb-8 flex items-center gap-3">
            <span>{index}</span>
            <span className="w-16 h-px bg-primary" />
            <Link to="/" className="text-muted-foreground hover:text-primary">Home</Link>
            <span className="text-muted-foreground">/ {title}</span>
          </div>
        </Reveal>
        <div className="flex flex-col lg:flex-row lg:items-end gap-8 lg:gap-16">
          <h1 className="font-head font-black text-[1.8rem] min-[380px]:text-[2.2rem] sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl tracking-tightest leading-[0.95] flex-1">
            <LineReveal lines={lines} />
          </h1>
          {logo && (
            <img
              src="/images/ghs-logo-full.png?v=4"
              alt="GHS SpA — Greenhouse Solutions SPA"
              width="636"
              height="340"
              data-testid="page-header-logo"
              className="w-52 sm:w-64 md:w-80 lg:w-96 h-auto shrink-0 self-start lg:self-end lg:mb-3"
              loading="eager"
            />
          )}
        </div>
        {subtitle && (
          <Reveal delay={0.4}>
            <p className="mt-8 max-w-2xl text-lg text-muted-foreground leading-relaxed">{subtitle}</p>
          </Reveal>
        )}
        {image && (
          <ImageReveal delay={0.35} className="mt-14">
            <div className="relative aspect-[21/9] overflow-hidden border border-border">
              <img src={image} alt={title} loading="eager" decoding="async" className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-foreground/10" />
            </div>
          </ImageReveal>
        )}
      </div>
    </section>
  );
}
